import { XIcon } from '@heroicons/react/outline';
import { useState } from 'react';

type Props = {
  children?: React.ReactNode;
};

export default function TopFixedBanner({ children }: Props) {
  const [show, setShow] = useState(true);
  const onClose = () => setShow(false);
  return (
    <div className="relative bg-primary" hidden={!show}>
      <div className="px-3 py-3 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="sm:pr-16 pr-0 sm:text-center sm:px-16">
          <p className="text-white text-center">{children}</p>
        </div>
        <div className="absolute inset-y-0 right-0 flex items-start pt-1 pr-1 sm:pt-1 sm:pr-2 sm:items-start">
          <button
            type="button"
            className="flex p-2 rounded-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-white"
            onClick={onClose}
          >
            <span className="sr-only">Dismiss</span>
            <XIcon className="w-6 h-6 text-white" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
